import { sortBy } from 'lodash';
import { RootState } from '..';
import { MethodDto } from './method';

export const selectMethods = (state: RootState) =>
  sortBy(state.methods.methods, 'name');

export const selectMethodErrors = (state: RootState) => state.methods.errors;

export const selectMethodsBy = (
  state: RootState,
  func: (m: MethodDto) => boolean
) => sortBy(state.methods.methods.filter(func), 'name');
